import axios from '@/utils/api'
import Crezu from '@/utils/'

export const pushGAEvent = function({ commit, state, dispatch, getters }, event) {
  console.log(`%c PUSH GA Event:`, 'color: green; background: black', event)
  const lead_id = state.additionalParams.lead_id || localStorage.getItem('leadId') || localStorage.getItem('lead_id')
  window.dataLayer = window.dataLayer || []
  if (typeof event === 'object') {
    if (event.event === 'FirstStepSubmitted') {
      // init cc pixel (concat leads between sites)
      dispatch('ccIframeInit')
      try {
        if (window.ttq) window.ttq.track('SubmitForm', {}, { event_id: lead_id })
      } catch (e) {
      }
      dispatch('pushCustomEvent', { name: event.event, value: event.state })
      delete event.state
      dispatch('sendCrezuEvent', { id: 3 })
      dispatch('sendCrezuEvent', {
        id: 5,
        data: {
          sub4: 'leadCreated',
          sub5: +state.leadStatus,
        }
      })
    }
    window.dataLayer.push(event)
  } else if (event === 'formFillingHistoryDropped' || event === 'formFillingHistorySuccess') {
    commit('UPDATE_FIELD_TIMING')
    window.dataLayer.push({
      'event': event,
      'eventCategory': 'Form Filling',
      'eventAction': JSON.stringify(state.historyToDataLayer),
      'lead_id': lead_id
    })
    if (event === 'formFillingHistorySuccess') window.succesRedirect = true
  } else {
    window.dataLayer.push({
      'event': event
    })
  }
}

export const initGAHistory = function({ commit, dispatch, state }, auth) {
  console.log(`%c 👻 FLOW: ${state.flow}`, 'color: lightblue; background: black')
  if (auth) {
    dispatch('pushGAEvent', 'Auth')
    dispatch('pushGAEvent', {
      event: 'GAevent',
      eventCategory: 'form',
      eventAction: 'send',
      eventLabel: `logging_in`
    })
    dispatch('sendCrezuEvent', { id: 2 })
    dispatch('sendCrezuEvent', { id: 5, data: { sub4: 'auth' } })
  } else {
    if (state.flow === 'standart') {
      dispatch('pushGAEvent', 'startedFromFirstStep')
    }
  }
  // init time tracker and fields history for GA
  commit('PUSH_FIELD_TO_DATALAYER', state.history[state.currentStep].name)
}

export const pushFBEvent = function({ commit, state }, params) {
  try {
    // eslint-disable-next-line no-undef
    if (window.fbq) fbq(params.track, params.event, params.data)
  } catch (e) {
    console.warn(e)
  }
}

export const pushPercents = function({ commit, state, dispatch }) {
  const percents = state.config.params.progress_bar.percents[state.history[state.currentStep].name] || 1
  commit('UPDATE_PERCENTS', percents)
  dispatch('pushCustomEvent', { name: 'progress_changed', value: state.progressPercents })
}

export const pushCustomEvent = function({ commit, state }, data) {
  const event = new CustomEvent(data.name, { 'detail': data.value })
  window.dispatchEvent(event)
}

export const hubEvent = function({ commit, state }, params) {
  let formData = new FormData()
  for (const i in params) {
    formData.set(i, params[i])
  }
  axios({
    method: 'POST',
    url: `${state.backendUrl}/webhook`,
    data: formData,
    headers: { 'Content-Type': 'application/json' }
  }).then((response) => {
    console.log('success', response.data)
  }, (error) => {
    console.log(error)
  })
}

export const ccIframeInit = function() {
  let a = 'cc_iframe'
  let b = document.createElement('iframe')
  b.id = a
  document.body.appendChild(b)
  document.getElementById(a).style.display = 'none'
  let li = localStorage.getItem('leadId') || localStorage.getItem('lead_id')
  let ts = +new Date()
  document.getElementById(a).src = 'https://clicfin.com/?li=' + li + '&ts=' + ts
}

export const sendFormStepLandedEvent = ({ state, commit, dispatch }) => {
  const regFormVisitNumberLS = localStorage.getItem('regFormVisitNumber')
  const regFormVisitNumber = regFormVisitNumberLS ? +regFormVisitNumberLS + 1 : 0
  localStorage.setItem('regFormVisitNumber', `${regFormVisitNumber}`)
  dispatch('sendCrezuEvent', { id: 21, data: { sub7: window.location.href } })
  dispatch('sendCrezuEvent', { id: 5, data: { sub4: 'formOpen', sub5: regFormVisitNumber } })
  commit('CHANGE_ADDITIONAL_PARAMS', { session_id: Crezu.common.getCookie('session_id') })

  if (Crezu.common.getURLParameter('utm_campaign')) {
    // send SITE_OPEN event if user traps directly to reg form (not from index)
    dispatch('sendCrezuEvent', { id: 1 })
  }
}

export const sendCrezuEvent = ({ state }, event) => {
  const lead_id = Crezu.common.getURLParameter('lead_id') || state.additionalParams.lead_id || localStorage.getItem('leadId') || localStorage.getItem('lead_id')
  const data = {
    event_id: event.id,
    provider_id: state.additionalParams.provider,
    sub1: lead_id,
    sub3: state.additionalParams.exp_flow,
    ...event.data
  }
  if (event.id === 5 && event.data && ['fieldFocus', 'fieldFilled', 'fieldInvalid'].includes(event.data.sub4)) {
    data.sub8 = state.history[state.currentStep].name
  }
  if (window.location.hostname === 'localhost') {
    console.log('Crezu event:', data)
    return
  }
  Crezu.events.crezuEvent(data)
}



// WEBPACK FOOTER //
// ./src/store/helpers/analytics-actions.js